<template>
  <v-list class="primacard-category-list">
    <v-list-item
      v-for="item in content"
      :key="item.id"
      class="primacard-category-list-item"
    >
      <router-link
        class="primacard-category-list-item-link"
        :to="{ name: 'PrimaCardList', params: { categoryName: item.slug } }"
        v-html="item.name"
        @click="clicked"
      ></router-link>
    </v-list-item>
  </v-list>
</template>
<style lang="scss">
.primacard-category-list {
  padding: 16px;
  .primacard-category-list-item {
    min-height: 20px;
    padding: 8px 16px 8px 0;
    border-bottom: 1px rgba(128, 128, 128, 0.33) solid;
  }
  .primacard-category-list-item-link {
    font-size: 13px;
    font-style: normal;
    font-weight: 500;
    line-height: 26px;
    letter-spacing: 0px;
    text-align: left;
    text-transform: uppercase;
    color: $text-color;
    text-decoration: none;
    &.router-link-active {
      font-weight: bold;
    }
  }
}
</style>
<script>
import CMSService from "~/service/cmService";
import clickHandler from "~/mixins/clickHandler";

export default {
  name: "PrimacardCategory",
  data() {
    return {
      content: null
    };
  },
  mixins: [clickHandler],
  created() {
    this.fetchPage();
  },
  methods: {
    async fetchPage() {
      let res = await CMSService.getCustomPostByFilters("categoria_primacard");
      this.content = res.data;
    }
  }
};
</script>
